import axios from 'axios';
import store from '@/store';

// set base for our api
axios.defaults.baseURL = process.env.API_ENDPOINT;

// we want to step in and use bearer token authentication on all requests to the API
axios.interceptors.request.use(cfg => {

	if (store.getters.isAuthenticated) {
		const auth = store.getters.getAuth;
		cfg.headers.Authorization = `${auth.token_type} ${auth.access_token}`;
	}

	return cfg;
}, err => Promise.reject(err));

export default axios;


// WEBPACK FOOTER //
// ./src/axios/index.js